<template>
    <v-container id="result-statistics">
        <v-row align="center" justify="center">
            <v-col cols="12" md="12" lg="11" xl="11" justify="center" align="center" style="">
                <v-divider></v-divider>
                <div style="margin-left:20px;text-align:left;">
                    <h3 class="text-h5 font-weight-light">Statistics</h3>
                </div>
            </v-col>
        </v-row>
        <v-row align="center" justify="center">
            <v-col cols="12" md="10" lg="18" xl="8" justify="center" align="center" style="">
                <v-table class="elevation-1" style="padding:20px;background-color:#f8f8f8;">
                    <tr>
                        <td style="text-align:center;">
                            <div v-html="this.$store.getters.getProcessState('load-results')"></div>
                        </td>
                    </tr>
                    <tr>
                        <td>Results for </td><td>{{ this.$store.getters.queryIdentifier }}</td>
                    </tr>
                    <tr>
                        <td>Genome version</td><td>{{ this.$store.getters.genomeVersion }}</td>
                    </tr><tr></tr>
                    <tr>
                        <td>Identified Biomarkers</td>
                    </tr>
                    <tr>
                        <td>Biomarkers classified as likely pathogenic</td>
                    </tr>
                    <tr>
                        <td>Exact match clinically significant treatments found: </td>
                    </tr>
                    <tr>
                        <td>Total number of possible treatments found</td>
                    </tr>
                </v-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

</script>
<style>
</style>
